"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { BookOpen, Smartphone, FolderLock } from "lucide-react";
export default function TheExperience() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: columnsRef,
    isVisible: columnsVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const columns = [{
    icon: BookOpen,
    heading: "YOUR HERITAGE COMPENDIUM",
    title: "Your Print-Ready Masterpiece",
    description: "You receive a high‑resolution digital master of your signature design Heritage Compendium. custom‑designed in a 12×10 inch prestige format, and this file is optimised for luxury lay‑flat printing, allowing your family to produce as many physical heirlooms as desired, anywhere in the world."
  }, {
    icon: Smartphone,
    heading: "YOUR HERITAGE EXPERIENCE",
    title: "Your Living Narrative",
    description: "You receive a stunning digital Interactive Flipbook edition of your Heritage Compendium. This immersive experience allows your descendants to navigate your life's journey with a simple touch, turning digital pages that feel like a physical book. Embedded within the narrative are your Wisdom Audio Clips—allowing the resonance, tone, and spirit of your voice to guide your heirs through your most vital lessons, creating an intimate connection that transcends generations. To ensure this legacy remains effortless to access, a QR code to your Heritage Experience is integrated into the design, allowing any heir, anywhere in the world, to instantly summon your wisdom with a simple scan—today, or any time in the future."
  }, {
    icon: FolderLock,
    heading: "YOUR FAMILY LEGACY ARCHIVE",
    title: "Your Eternal Record",
    description: "Your entire family wisdom legacy is preserved within a secure, private digital archive. This master collection—containing your Heritage Compendium, Interactive Heritage Experience flipbook, and transcribed wisdom—is hosted in a dedicated Google Drive folder for one year. During this sovereign handover period, you are encouraged to download and transfer your files to your family's private servers, ensuring you hold total, permanent sovereignty over your family's most precious intellectual property."
  }];
  return <section id="the-experience" className="relative bg-[#0A192F] py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {}
        <div ref={headerRef} className="text-center mb-12 sm:mb-16 transition-all duration-700 ease-out" style={{
        opacity: headerVisible ? 1 : 0,
        transform: headerVisible ? "translateY(0)" : "translateY(20px)"
      }}>
          <h2 className="font-[var(--font-cinzel)] tracking-[4px] leading-[1.35] text-[#F1D592] inline-block px-6 py-3 rounded-md mb-4 !font-bold !text-[40px] sm:px-8 sm:py-4">Your Family Legacy Experience</h2>
          <p className="font-['Lato',sans-serif] italic text-[20px] leading-[1.35] text-[#F1D592] mt-4 text-center sm:text-[22px]">Meticulously designed and created with love, so your voice remains a presence in their lives forever.</p>
        </div>

        {}
        <div ref={columnsRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {columns.map((column, i) => {
          const IconComponent = column.icon;
          return <div key={i} data-index={i} className="flex flex-col transition-all duration-700 ease-out" style={{
            opacity: columnsVisible ? 1 : 0,
            transform: columnsVisible ? "translateY(0)" : "translateY(30px)",
            transitionDelay: `${i * 100}ms`
          }}>
                <div className="bg-[#112240] border border-[#F1D592] rounded shadow-md p-10 flex flex-col h-full">
                  {}
                  <div className="flex justify-center mb-6">
                    <IconComponent className="w-12 h-12 text-[#F1D592]" />
                  </div>
                  
                  {}
                  <div className="mb-4">
                    <h3 className="font-[var(--font-montserrat)] font-semibold text-[16px] sm:text-[18px] tracking-[2px] leading-[1.3] text-[#F1D592] uppercase text-center">
                      {column.heading}
                    </h3>
                  </div>
                  
                  {}
                  <h4 className="font-['Playfair_Display',serif] font-semibold text-[20px] sm:text-[22px] leading-[1.3] text-[#F1D592] mb-4 text-center">
                    {column.title}
                  </h4>
                  
                  {}
                  <p className="font-sans text-[16px] sm:text-[18px] leading-[1.6] text-[#F5F5DC]">
                    {column.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}